import { render } from "./PageNotValid.vue?vue&type=template&id=b538fb60&scoped=true"
import script from "./PageNotValid.vue?vue&type=script&lang=js"
export * from "./PageNotValid.vue?vue&type=script&lang=js"

import "./PageNotValid.vue?vue&type=style&index=0&id=b538fb60&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b538fb60"]])

export default __exports__